import { MembershipRuleValue } from '../../types/membership';
import { CheckMembershipFeedbackError } from '../implementations';
import { Rule } from '../types/Rule';
import { RuleSetStrategy } from './RuleSetStrategy';

export class MembershipRuleSetStrategy implements RuleSetStrategy<MembershipRuleValue> {
  getRules(): Rule<MembershipRuleValue>[] {
    return [
      new CheckMembershipFeedbackError(),
    ];
  }
}
